import { fetchConToken } from "../helpers/fetch"
import { armarParametrosDisca } from "../helpers/parametros";

const DiscapacidadService = {
  getSolicitudesAuditoria: (
    idAfiliado,
    idCodNom,
    idSolicitud,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud
  ) => {
    return fetchConToken(
      `SolicitudIntegracion/traerAuditoria?${armarParametrosDisca(
        idAfiliado,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        idEstadoSolicitud,
        idCodNom
      )}`
    );
  },
  getContadoresSolicitudesIntegracion: (
    idAfiliado,
    idCodNom,
    idSolicitud,
    fechaDesde,
    fechaHasta) => {
    return fetchConToken(
      `SolicitudIntegracion/traerContadores?${armarParametrosDisca(
        idAfiliado,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        null,
        idCodNom
      )}`
    );
  },
  getTiposPrestaciones: () => {
    return fetchConToken(`TipoPrestacion`)
  },
  getTiposSolicitudes: () => {
    return fetchConToken(`TipoSolicitudIntegracion`)
  },
  getTiposTransporteDiscapacidad: () => {
    return fetchConToken(`TipoTransporte`)
  },
  getSubTipoSolicitudes: () => {
    return fetchConToken(`SubTipoSolicitudIntegracion`)
  },
  postSolicitud: (data) => {
    return fetchConToken(`SolicitudIntegracion`, data, "POST");
  },
  putSolicitud: (data) => {
    return fetchConToken(`SolicitudIntegracion`, data, "PUT");
  },
  putCancelarSolicitud: (data) => {
    return fetchConToken(`SolicitudIntegracion/cancelarSolicitud`, data, "PUT");
  },
  postPracticas: (data) => {
    return fetchConToken(`PracticaSolicitudIntegracion`, data, "POST");
  },
  putPeriodos: (data) => {
    return fetchConToken(`PeriodoSolicitudIntegracion`, data, 'PUT');
  },
  anularPeriodo: (idSolicitud, periodo) => {
    return fetchConToken(`SolicitudIntegracion/AnularPeriodo/${idSolicitud}/${periodo}`, {}, 'PUT')
  },
  putEstadoSolicitud: (data) => {
    return fetchConToken(`SolicitudIntegracion/modificarEstado`, data, "PUT");
  },
  getNotas: (idSolicitud) => {
    return fetchConToken(`SolicitudIntegracion/traerPorSolicitud/${idSolicitud}`);
  },
  deleteNota: (data) => {
    return fetchConToken(`SolicitudIntegracion`, data, "DELETE");
  },
  traerNomencladorIntegracion: (codigoNombre) => {
    return fetchConToken(`NomencladorIntegracion?codigoNombre=${codigoNombre}`);
  },
  //TRACKING SOLICITUD
  getTrackingSolicitudIntegracion: (idSolicitud) => {
    return fetchConToken(
      `TrackingSolicitudIntegracion/traerPorSolicitud/${idSolicitud}`
    );
  },
  //EXPORT PDF POR ID SOLICITUD INTEGRACION
  generatePdfPorIdSolicitudIntegracion: (
    idSolicitud,
    idEstadoSolicitud
  ) => {
    return fetchConToken(
      `SolicitudIntegracion/exportPdfSolicitud?${armarParametrosDisca(
        null,
        null,
        null,
        idSolicitud,
        null,
        null
      )}`
    );
  },
  postNota: (data, method) => {
    if (method === "POST")
      return fetchConToken(`SolicitudIntegracion/nota`, data, "POST");
    else {
      return fetchConToken(`SolicitudIntegracion/nota/${data.idNota}`, data, "PUT");
    }
  },
  //AUGO-GESTION
  getMisSolicitudesDiscapacidad: (idAfiliado, idEstado) => {
    return fetchConToken(`SolicitudIntegracion/traerPorAfiliado?idAfiliado=${idAfiliado}&idEstado=${idEstado}`)
  },
  //TIPO DOCUMENTACION
  getAllTiposDocumentacionIntegracion: () => {
    return fetchConToken(`TipoDocumentacionIntegracion`);
  },
  postTipoDocumentacionIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionIntegracion`, data, "POST");
  },
  putTipoDocumentacionIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionIntegracion`, data, "PUT");
  },
  deleteTipoDocumentacionIntegracion: (id) => {
    return fetchConToken(`TipoDocumentacionIntegracion/${id}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACION SOLICITUD
  getTiposDocumentacionSolicitudIntegracion: (idTipoSolicitud) => {
    return fetchConToken(`TipoDocumentacionSolicitudIntegracion/traerPorTipoSolicitud/${idTipoSolicitud}`);
  },
  getAllTiposDocumentacionSolicitudIntegracion: () => {
    return fetchConToken(`TipoDocumentacionSolicitudIntegracion`);
  },
  postTipoDocumentacionSolicitudIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionSolicitudIntegracion`, data, "POST");
  },
  putTipoDocumentacionSolicitudIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionSolicitudIntegracion`, data, "PUT");
  },
  deleteTipoDocumentacionSolicitudIntegracion: (id) => {
    return fetchConToken(`TipoDocumentacionSolicitudIntegracion/${id}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACION AFILIADO 
  getAllTiposDocumentacionAfiliadoIntegracion: () => {
    return fetchConToken(`TipoDocumentacionAfiliadoIntegracion`);
  },
  postTipoDocumentacionAfiliadoIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionAfiliadoIntegracion`, data, "POST");
  },
  putTipoDocumentacionAfiliadoIntegracion: (data) => {
    return fetchConToken(`TipoDocumentacionAfiliadoIntegracion`, data, "PUT");
  },
  deleteTipoDocumentacionAfiliadoIntegracion: (id) => {
    return fetchConToken(`TipoDocumentacionAfiliadoIntegracion/${id}`, {}, "DELETE");
  },
  //DOCUMENTACION SOLICITUD
  getDocumentacionSolicitudIntegracion: (idSolicitud) => {
    return fetchConToken(`DocumentacionSolicitudIntegracion/${idSolicitud}`);
  },
  deleteDocumentacionSolicitudIntegracion: (idDocumento) => {
    return fetchConToken(
      `DocumentacionSolicitudIntegracion/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //DOCUMENTACION AFILIADO
  getDocumentacionAfiliadoIntegracion: (idAfiliado) => {
    return fetchConToken(`DocumentacionAfiliadoIntegracion/${idAfiliado}`);
  },
  deleteDocumentacionAfiliadoIntegracion: (idDocumento) => {
    return fetchConToken(
      `DocumentacionAfiliadoIntegracion/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //SOLICITUDES TOMADAS
  getSolicitudesTomadasPorUsuario: () => {
    return fetchConToken(`SolicitudesIntegracionTomadas/traerPorUsuario`);
  },
  getSolicitudesTomadas: () => {
    return fetchConToken(`SolicitudesIntegracionTomadas/traerTomadas`);
  },
  putLiberarSolicitud: (id) => {
    return fetchConToken(`SolicitudesIntegracionTomadas`, { id }, "PUT");
  },
  postTomarSolicitud: (idSolicitud) => {
    return fetchConToken(`SolicitudesIntegracionTomadas`, { idSolicitud }, "POST");
  },
  //FORMULARIO CUD
  getFormularioCud: (idAfiliado) => {
    return fetchConToken(`FormularioCud/${idAfiliado}`);
  },
  postFormularioCud: (data) => {
    return fetchConToken(`FormularioCud`, data, "POST");
  },
  putFormularioCud: (data) => {
    return fetchConToken(`FormularioCud`, data, "PUT");
  },

  //NOMENCLADOR DISCAPACIDAD

  putValorizacion: (idValorizacion, data) => {
    return fetchConToken(`Discapacidad/EditValorizacion/${idValorizacion}`, data, "PUT");
  },

  deleteValorizacion: (idValorizacion, data) => {
    return fetchConToken(
      `Discapacidad/DeleteValorizacion/${idValorizacion}`,
      data,
      "PUT"
    );
  },
  //consumos afiliado
  getConsumosAfiliados: (idAfiliado) => {
    return fetchConToken(
      `SolicitudIntegracion/TraerConsumosAfiliado/${idAfiliado}`
    );
  }
}
export { DiscapacidadService as default }